import { render, staticRenderFns } from "./LaudoCroqui.vue?vue&type=template&id=ec45de86&scoped=true&lang=pug"
import script from "./LaudoCroqui.vue?vue&type=script&lang=js"
export * from "./LaudoCroqui.vue?vue&type=script&lang=js"
import style0 from "./LaudoCroqui.vue?vue&type=style&index=0&id=ec45de86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec45de86",
  null
  
)

export default component.exports